module.exports = __webpack_public_path__ + "static/media/Inter-Light-BETA.8a49915c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Light-BETA.woff
// module id = 693
// module chunks = 21